module.exports = __webpack_public_path__ + "static/sliderplaceholder2-8dffa491c23628f6e1f11cd1f3053215.jpg";